<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="330px">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{ $vuetify.lang.t('$vuetify.lineRegisCodeModal.lineRegisterCode') }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.lineRegisCodeModal.code')"
                                        v-model="form.code"
                                        readonly
                                        placeholder=" "
                                        persistent-hint>
                                        <v-tooltip slot="append" top>
                                        <template #activator="{ on }">
                                           <v-icon @click="copyLineCode" v-on="on" >content_copy</v-icon>
                                        </template>
                                        <span> {{ copy }} </span>
                                        </v-tooltip>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="grey darken-2"
                        text
                        @click="closeModal()">
                        {{ $vuetify.lang.t('$vuetify.lineRegisCodeModal.cancel') }}
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="submit()">
                        {{ $vuetify.lang.t('$vuetify.lineRegisCodeModal.create') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

export default {
    name: 'LineRegisCodeModal',

    data () {
        return {
            dialog: false,
            copy: this.$vuetify.lang.t('$vuetify.lineRegisCodeModal.copy'),
            form: {
                code: ''
            },
            employeeId: null
        }
    },

    methods: {
        async openModal (employeeId) {
            this.employeeId = employeeId
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.get(`employee/line_regis_code/${this.employeeId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.form.code = res.data.regisCode
                this.dialog = true
                this.$store.dispatch('setLoading', false)
            }
        },

        copyLineCode () {
            this.$copyText(this.form.code).then((e) => navigator.clipboard.writeText(e.text))
            this.copy = this.$vuetify.lang.t('$vuetify.lineRegisCodeModal.copied')
        },

        closeModal () {
            this.dialog = false
            this.copy = this.$vuetify.lang.t('$vuetify.lineRegisCodeModal.copy')
        },

        async submit () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post(`employee/line_regis_code/${this.employeeId}/create`)
            if (res && res.data && res.data.status === 'ok') {
                this.form.code = res.data.regisCode
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    watch: {
        '$vuetify.lang.current' (newValue, oldValue) {
            this.copy = this.$vuetify.lang.t('$vuetify.lineRegisCodeModal.copy')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
